<template>
  <div class="row" style="margin-bottom: 20px; margin-left: 5px">
    <div class="card bg-primary bg-gradient text-white" style="width: 18rem">
      <div class="card-body">
        <h1 class="card-title">{{ totalTrips }}</h1>
        <h6 class="card-subtitle mb-2 text-body-secondary">Trips</h6>
      </div>
    </div>

    <div class="card bg-secondary bg-gradient text-white" style="width: 18rem; margin-left: 20px">
      <div class="card-body">
        <h1 class="card-title">{{ totalDistance }}KM</h1>
        <h6 class="card-subtitle mb-2 text-body-secondary">Distance Travelled</h6>
      </div>
    </div>

    <div class="card bg-info  bg-gradient text-white" style="width: 18rem; margin-left: 20px">
      <div class="card-body">
        <h1 class="card-title">
          {{ totalEmissions }}
        </h1>
        <h6 class="card-subtitle mb-2 text-body-secondary">Emissions</h6>
      </div>
    </div>

    <div class="card bg-dark bg-gradient text-white" style="width: 18rem; margin-left: 20px">
      <div class="card-body">
        <h1 class="card-title">{{ totalFuelBurned }}L</h1>
        <h6 class="card-subtitle mb-2 text-body-secondary">Fuel Burned</h6>
      </div>
    </div>
    <div class="card bg-danger bg-gradient text-white" style="width: 18rem; margin-left: 20px">
      <div class="card-body">
        <h1 class="card-title">${{ totalFuelCost }}</h1>
        <h6 class="card-subtitle mb-2 text-body-secondary">Fuel Cost</h6>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'VehicleTripsSummary',
  props:{
    totalTrips: Number,
    totalDistance: Number,
    totalEmissions: Number,
    totalFuelBurned: Number,
    totalFuelCost: Number
  }
}
</script>
